import { SPLIT_TEST_NAME } from './SPLIT_TESTS';
import { useAnonymousSplitTests } from './useAnonymousSplitTests';

export function useIsInStep0EligibilityTest(): boolean {
  const splitTests = useAnonymousSplitTests({
    testFilter: SPLIT_TEST_NAME.NEW_CUSTOMERS_STEP_0_ELIGIBILITY_2026,
    // Launch gate. Swap for useLocale's isUK to start enrolling — UK only.
    enabled: false,
  });

  return splitTests?.[0]?.branch_name === 'INCLUDE';
}
